(function () {
  'use strict';

  function getCheckoutRoot() {
    var base = (window.BB_CHECKOUT && window.BB_CHECKOUT.baseUrl) || 'https://checkout.lifesofbooks.com';
    try {
      return new URL(String(base).trim()).origin;
    } catch (e) {
      return 'https://checkout.lifesofbooks.com';
    }
  }

  var ATTRIBUTION_PARAMS = [
    'fbclid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
  ];

  function appendAttributionParams(url) {
    var current = new URLSearchParams(window.location.search);
    ATTRIBUTION_PARAMS.forEach(function (key) {
      var value = current.get(key);
      if (value) url.searchParams.set(key, value);
    });
  }

  function buildProductParam(handle, variantId, variantCount, urlVariantId) {
    var count = parseInt(variantCount, 10) || 1;
    var vid = urlVariantId || variantId;
    if (handle && (count > 1 || urlVariantId)) {
      return handle + ':' + vid;
    }
    if (handle) return handle;
    return String(vid || '');
  }

  function buildCheckoutUrl(productParam) {
    var url = new URL(getCheckoutRoot() + '/checkout');
    url.searchParams.set('product', productParam);
    appendAttributionParams(url);
    return url.toString();
  }

  function checkoutUrlFromCart(cart) {
    var url = new URL(getCheckoutRoot() + '/checkout');
    if (!cart || !cart.items || !cart.items.length) {
      appendAttributionParams(url);
      return url.toString();
    }
    var items = cart.items.map(function (item) {
      return item.variant_id + ':' + item.quantity;
    }).join(',');
    url.searchParams.set('items', items);
    appendAttributionParams(url);
    return url.toString();
  }

  function checkoutUrlFromDataset(el) {
    if (!el) {
      var fallback = new URL(getCheckoutRoot() + '/checkout');
      appendAttributionParams(fallback);
      return fallback.toString();
    }
    var handle = el.getAttribute('data-product-handle');
    var variantId = el.getAttribute('data-variant-id');
    var variantCount = el.getAttribute('data-variant-count') || '1';
    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    return buildCheckoutUrl(buildProductParam(handle, variantId, variantCount, urlVariant));
  }

  function redirectToCustomCheckout() {
    return fetchCart().then(function (cart) {
      if (!cart.items || cart.items.length === 0) {
        window.location.href = '/cart';
        return;
      }
      window.location.href = checkoutUrlFromCart(cart);
    });
  }

  function initCustomCheckout() {
    document.addEventListener('click', function (e) {
      var cartCheckout = e.target.closest('[data-bb-cart-checkout]');
      if (cartCheckout) {
        e.preventDefault();
        redirectToCustomCheckout();
        return;
      }

      var buyLink = e.target.closest('[data-bb-checkout-link]');
      if (buyLink) {
        e.preventDefault();
        window.location.href = checkoutUrlFromDataset(buyLink);
      }
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link || link.hasAttribute('data-bb-checkout-link') || link.hasAttribute('data-bb-cart-checkout')) return;
      var href = link.getAttribute('href') || '';
      if (href === '/checkout' || href.indexOf('/checkout?') === 0 || href.indexOf('checkout.shopify.com') !== -1) {
        e.preventDefault();
        redirectToCustomCheckout();
      }
    }, true);
  }

  function initCountdown() {
    document.querySelectorAll('[data-bb-countdown]').forEach(function (el) {
      var timer = el.querySelector('[data-bb-timer]');
      if (!timer) return;

      function tick() {
        var now = new Date();
        var midnight = new Date();
        midnight.setHours(24, 0, 0, 0);
        var remaining = midnight - now;
        if (remaining <= 0) {
          timer.textContent = '00:00:00';
          return;
        }
        var hrs = Math.floor(remaining / 3600000);
        var mins = Math.floor((remaining % 3600000) / 60000);
        var secs = Math.floor((remaining % 60000) / 1000);
        timer.textContent =
          String(hrs).padStart(2, '0') + ':' +
          String(mins).padStart(2, '0') + ':' +
          String(secs).padStart(2, '0');
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  function initStickyCart() {
    var sticky = document.querySelector('[data-bb-sticky-cart]');
    if (!sticky) return;

    window.addEventListener('scroll', function () {
      var scrollTop = window.scrollY;
      var windowHeight = window.innerHeight;
      var documentHeight = document.documentElement.scrollHeight;
      var show = scrollTop > 900 && scrollTop + windowHeight < documentHeight - 100;
      document.body.classList.toggle('sticky__add-to-cart', show);
      document.body.classList.toggle('bb-sticky-visible', show);
    }, { passive: true });
  }

  function initSaleDate() {
    var el = document.querySelector('[data-bb-sale-date]');
    if (!el) return;
    var now = new Date();
    var months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
    el.textContent = months[now.getMonth()] + ' ' + String(now.getDate()).padStart(2, '0');
  }

  function applyCountryFlag(flag, code) {
    if (!flag || !code) return;
    var country = String(code).toLowerCase();
    flag.src = 'https://flagcdn.com/64x48/' + country + '.png';
    flag.alt = country.toUpperCase() + ' flag';
    flag.dataset.bbCountryCode = country;
    flag.style.display = 'inline-block';
    flag.removeAttribute('data-bb-country-pending');
  }

  function resolveCountryCode() {
    var bodyCountry = document.body && document.body.dataset.visitorCountry;
    if (bodyCountry) return Promise.resolve(bodyCountry.toLowerCase());

    if (window.Shopify && Shopify.country) {
      return Promise.resolve(String(Shopify.country).toLowerCase());
    }

    return fetch('https://ipapi.co/json/')
      .then(function (response) {
        if (!response.ok) throw new Error('geo lookup failed');
        return response.json();
      })
      .then(function (data) {
        return data && data.country_code ? String(data.country_code).toLowerCase() : null;
      })
      .catch(function () { return null; });
  }

  function initCountryFlag() {
    document.querySelectorAll('[data-bb-country-flag]').forEach(function (flag) {
      if (flag.dataset.bbCountryCode) return;

      resolveCountryCode().then(function (code) {
        if (code) applyCountryFlag(flag, code);
      });
    });
  }

  function initVideos() {
    document.querySelectorAll('[data-bb-video-wrap]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var playBtn = wrap.querySelector('[data-bb-play]');
      if (!video || !playBtn) return;

      video.pause();

      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        document.querySelectorAll('[data-bb-video-wrap] video').forEach(function (v) {
          if (v !== video) {
            v.pause();
            var btn = v.closest('[data-bb-video-wrap]');
            if (btn) {
              var p = btn.querySelector('[data-bb-play]');
              if (p) p.style.display = 'flex';
            }
          }
        });
        video.play();
        playBtn.style.display = 'none';
      });

      wrap.addEventListener('click', function () {
        if (!video.paused) {
          video.pause();
          playBtn.style.display = 'flex';
        }
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('.faq-head').forEach(function (faqHead) {
      function toggle() {
        var faqContent = faqHead.nextElementSibling;
        if (!faqContent || !faqContent.classList.contains('faq-content')) return;

        document.querySelectorAll('.faq-content').forEach(function (content) {
          if (content !== faqContent) {
            content.style.maxHeight = null;
            content.classList.remove('open');
            var prev = content.previousElementSibling;
            if (prev) {
              prev.classList.remove('open');
              prev.setAttribute('aria-expanded', 'false');
            }
          }
        });

        if (faqContent.classList.contains('open')) {
          faqContent.style.maxHeight = null;
          faqContent.classList.remove('open');
          faqHead.classList.remove('open');
          faqHead.setAttribute('aria-expanded', 'false');
        } else {
          faqContent.style.maxHeight = faqContent.scrollHeight + 20 + 'px';
          faqContent.classList.add('open');
          faqHead.classList.add('open');
          faqHead.setAttribute('aria-expanded', 'true');
        }
      }

      faqHead.addEventListener('click', toggle);
      faqHead.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  var TRASH_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16" aria-hidden="true">' +
      '<path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/>' +
      '<path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/>' +
    '</svg>';

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function formatSaleEndDate() {
    var now = new Date();
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[now.getMonth()] + ' ' + String(now.getDate()).padStart(2, '0') + ', ' + now.getFullYear();
  }

  function savingsPercent(originalCents, finalCents) {
    if (!originalCents || originalCents <= finalCents) return 0;
    return Math.round((originalCents - finalCents) / originalCents * 100);
  }

  function lineCompareCents(item) {
    if (item.compare_at_price && item.compare_at_price > item.final_price) {
      return item.compare_at_price * item.quantity;
    }
    if (item.original_line_price > item.final_line_price) {
      return item.original_line_price;
    }
    if (item.final_line_price > 0) {
      return Math.max(item.final_line_price * 2, 990 * item.quantity);
    }
    return 0;
  }

  function cartCompareCents(cart) {
    return cart.items.reduce(function (sum, item) {
      return sum + lineCompareCents(item);
    }, 0);
  }

  function renderCartItem(item, currency) {
    var title = item.product_title || item.title || '';
    var escapedTitle = title.replace(/"/g, '&quot;');
    var compareCents = lineCompareCents(item);
    var compare = compareCents > item.final_line_price
      ? '<div class="cart_line-pricing_compare">' + formatMoney(compareCents, currency) + '</div>'
      : '';
    var savings = compareCents > item.final_line_price
      ? '<div class="cart_line-pricing_savings">50% OFF</div>'
      : '';
    var image = item.image
      ? '<img src="' + item.image + '" alt="' + escapedTitle + '" width="100" height="100" loading="lazy">'
      : '';

    return (
      '<div class="cart-item" data-bb-cart-line="' + item.key + '">' +
        '<a href="' + item.url + '" class="thumbnail">' + image + '</a>' +
        '<div class="content">' +
          '<a href="' + item.url + '" class="title">' + title + '</a>' +
          '<div class="cart_line-quantity" data-bb-cart-quantity>' +
            '<button type="button" class="cart_qty-btn cart_qty-btn--minus" aria-label="Decrease quantity" data-bb-cart-qty-minus data-bb-cart-line-key="' + item.key + '">−</button>' +
            '<span class="cart_qty-value" data-bb-cart-qty data-bb-cart-line-key="' + item.key + '">' + item.quantity + '</span>' +
            '<button type="button" class="cart_qty-btn cart_qty-btn--plus" aria-label="Increase quantity" data-bb-cart-qty-plus data-bb-cart-line-key="' + item.key + '">+</button>' +
          '</div>' +
          '<p class="cart_line-frequency">' +
            'Sale Ends Today: <span class="current_date_format" data-bb-cart-sale-date>' + formatSaleEndDate() + '</span>' +
          '</p>' +
          '<div class="cart_line-pricing">' + compare +
            '<div class="cart_line-pricing_sale">' + formatMoney(item.final_line_price, currency) + '</div>' +
            savings +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  var upsellCatalogCache = null;

  /** Never upsell kidney products; hide upsell block if cart has one (bible upsells may deter). */
  function isKidneyUpsellProduct(product) {
    var handle = (product && (product.handle || product.url || product.title || '')).toString().toLowerCase();
    return handle.indexOf('kidney') !== -1;
  }

  function cartHasKidneyProduct(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return isKidneyUpsellProduct({
        handle: item.handle,
        url: item.url,
        title: item.product_title || item.title,
      });
    });
  }

  function getUpsellCatalog() {
    if (upsellCatalogCache) return upsellCatalogCache;
    var el = document.querySelector('[data-bb-upsell-catalog]');
    if (!el) return [];
    try {
      upsellCatalogCache = JSON.parse(el.textContent);
    } catch (e) {
      upsellCatalogCache = [];
    }
    return upsellCatalogCache;
  }

  function upsellTitle(title) {
    if (/50%\s*off/i.test(title)) return title;
    return title + ' (50% OFF)';
  }

  function renderUpsellItem(product, currency) {
    var saveCents = Math.max(0, product.compare_at_price - product.price);
    var image = product.image
      ? '<img src="' + product.image + '" alt="" width="72" height="72" loading="lazy">'
      : '';
    return (
      '<div class="cart_upsell-item" data-bb-upsell-product="' + product.product_id + '">' +
        '<a href="' + product.url + '" class="cart_upsell-thumb">' + image + '</a>' +
        '<div class="cart_upsell-body">' +
          '<a href="' + product.url + '" class="cart_upsell-title">' + upsellTitle(product.title) + '</a>' +
          '<div class="cart_upsell-pricing">' +
            '<span class="cart_upsell-price">' + formatMoney(product.price, currency) + '</span>' +
            '<span class="cart_upsell-compare">' + formatMoney(product.compare_at_price, currency) + '</span>' +
            (saveCents > 0 ? '<span class="cart_upsell-save">You save ' + formatMoney(saveCents, currency) + '</span>' : '') +
          '</div>' +
          '<button type="button" class="cart_upsell-add" data-bb-upsell-add="' + product.variant_id + '">Add to cart</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderUpsell(cart) {
    var drawer = document.querySelector('[data-bb-cart-drawer]');
    if (!drawer) return;
    var upsellEl = drawer.querySelector('[data-bb-cart-upsell]');
    if (!upsellEl) return;

    if (!cart || !cart.items || !cart.items.length || cartHasKidneyProduct(cart)) {
      upsellEl.hidden = true;
      upsellEl.innerHTML = '';
      return;
    }

    var inCart = {};
    cart.items.forEach(function (item) {
      inCart[item.product_id] = true;
    });

    var upsells = getUpsellCatalog().filter(function (product) {
      return !inCart[product.product_id] && !isKidneyUpsellProduct(product);
    });

    if (!upsells.length) {
      upsellEl.hidden = true;
      upsellEl.innerHTML = '';
      return;
    }

    upsellEl.hidden = false;
    upsellEl.innerHTML =
      '<div class="cart_upsell-inner">' +
        upsells.map(function (product) {
          return renderUpsellItem(product, cart.currency);
        }).join('') +
      '</div>';
  }

  function changeLineQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return fetchCart(); })
      .then(renderCart);
  }

  function addUpsellToCart(variantId, button) {
    var originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add to cart');
          });
        }
        return fetchCart();
      })
      .then(renderCart)
      .catch(function (err) {
        console.error(err);
        alert(err.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel || 'Add to cart';
        }
      });
  }

  function renderCart(cart) {
    var drawer = document.querySelector('[data-bb-cart-drawer]');
    if (!drawer) return;

    var itemsEl = drawer.querySelector('[data-bb-cart-items]');
    var emptyEl = drawer.querySelector('[data-bb-cart-empty]');
    var filledEl = drawer.querySelector('[data-bb-cart-filled]');
    var subtotalEl = drawer.querySelector('[data-bb-cart-subtotal]');
    var compareEl = drawer.querySelector('[data-bb-cart-compare]');
    var savingsEl = drawer.querySelector('[data-bb-cart-savings]');
    var subtotalLabelEl = drawer.querySelector('[data-bb-cart-subtotal-label]');

    document.querySelectorAll('[data-bb-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    if (!cart.item_count) {
      drawer.classList.add('is-empty');
      if (emptyEl) emptyEl.hidden = false;
      if (filledEl) filledEl.hidden = true;
      if (itemsEl) itemsEl.innerHTML = '';
      renderUpsell(cart);
      return;
    }

    drawer.classList.remove('is-empty');
    if (emptyEl) emptyEl.hidden = true;
    if (filledEl) filledEl.hidden = false;
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(function (item) {
        return renderCartItem(item, cart.currency);
      }).join('');
    }
    if (subtotalLabelEl) {
      subtotalLabelEl.innerHTML = '<strong>Subtotal</strong>: ' + cart.item_count + ' Items';
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);

    var compareTotal = cartCompareCents(cart);
    if (compareEl) {
      if (compareTotal > cart.total_price) {
        compareEl.textContent = formatMoney(compareTotal, cart.currency);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (savingsEl) {
      if (compareTotal > cart.total_price) {
        savingsEl.textContent = '50% OFF';
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }

    var checkoutBtn = drawer.querySelector('[data-bb-cart-checkout]');
    if (checkoutBtn && cart.items.length) {
      checkoutBtn.href = checkoutUrlFromCart(cart);
    }

    renderUpsell(cart);
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-bb-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden', 'bb-cart-open');
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-bb-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden', 'bb-cart-open');
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-bb-cart-drawer]');
    if (!drawer) return;

    drawer.querySelectorAll('[data-bb-cart-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeCartDrawer();
      });
    });

    var overlay = drawer.querySelector('.cart-drawer__overlay');
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeCartDrawer();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    var cartIcon = document.querySelector('[data-bb-open-cart]');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(function (cart) {
          renderCart(cart);
          openCartDrawer();
        });
      });
    }

    drawer.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('[data-bb-cart-qty-minus]');
      var plusBtn = e.target.closest('[data-bb-cart-qty-plus]');
      if (minusBtn || plusBtn) {
        e.preventDefault();
        var qtyKey = (minusBtn || plusBtn).getAttribute('data-bb-cart-line-key');
        var qtyEl = drawer.querySelector('[data-bb-cart-qty][data-bb-cart-line-key="' + qtyKey + '"]');
        var qty = parseInt(qtyEl && qtyEl.textContent, 10) || 1;
        var nextQty = minusBtn ? qty - 1 : qty + 1;
        if (nextQty < 0) nextQty = 0;
        changeLineQuantity(qtyKey, nextQty);
        return;
      }

      var removeKey = e.target.closest('[data-bb-cart-remove]');
      if (removeKey) {
        e.preventDefault();
        changeLineQuantity(removeKey.getAttribute('data-bb-cart-remove'), 0);
        return;
      }

      var upsellBtn = e.target.closest('[data-bb-upsell-add]');
      if (upsellBtn) {
        e.preventDefault();
        addUpsellToCart(upsellBtn.getAttribute('data-bb-upsell-add'), upsellBtn);
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-bb-add-to-cart]');
      if (!form) return;
      e.preventDefault();

      var variantId = form.querySelector('[name="id"]').value;
      var btn = form.querySelector('button[type="submit"]');
      var originalLabel = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span>Adding…</span>';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || 'Could not add to cart');
            });
          }
          return fetchCart();
        })
        .then(function (cart) {
          renderCart(cart);
          openCartDrawer();
        })
        .catch(function (err) {
          console.error(err);
          alert(err.message || 'Could not add to cart. Please try again.');
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = originalLabel;
          }
        });
    });
  }

  function initFooterAccordion() {
    var titles = document.querySelectorAll('.footer_title1');
    if (!titles.length) return;

    titles.forEach(function (title) {
      title.addEventListener('click', function () {
        if (window.innerWidth > 767) return;
        var menu = title.closest('.footer-menu');
        if (!menu) return;
        var list = menu.querySelector('.footer_menu_wrap1');
        var isActive = menu.classList.contains('active');

        document.querySelectorAll('.footer-menu.active').forEach(function (openMenu) {
          if (openMenu !== menu) {
            openMenu.classList.remove('active');
            var openList = openMenu.querySelector('.footer_menu_wrap1');
            if (openList) openList.style.display = 'none';
          }
        });

        menu.classList.toggle('active', !isActive);
        if (list) list.style.display = isActive ? 'none' : 'block';
      });
    });
  }

  function initMenuDrawer() {
    document.querySelectorAll('.menu-drawer-container').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) {
          requestAnimationFrame(function () {
            details.classList.add('menu-opening');
          });
          document.body.classList.add('overflow-hidden');
        } else {
          details.classList.remove('menu-opening');
          if (!document.querySelector('[data-bb-cart-drawer].active')) {
            document.body.classList.remove('overflow-hidden');
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initStickyCart();
    initSaleDate();
    initCountryFlag();
    initFaq();
    initVideos();
    initMenuDrawer();
    initFooterAccordion();
    initCustomCheckout();
    initCartDrawer();
  });
})();
